// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#app {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  -webkit-font-smoothing: antialiased;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
}

#dashboard-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 100%;
}

#dashboard-layout__body {
    position: relative;
    display: flex;
    flex-grow: 1;
    width: 100%;
  }

:root {
  --text-color-primary-0: var(--color-grayscale-5);
  --text-color-primary-1: var(--color-grayscale-6);
  --text-color-primary-2: var(--color-grayscale-7);
  --text-color-primary-3: var(--color-grayscale-8);
  --theme-1-bg-color-selected-0: #fdfdfd;
  --theme-1-bg-color-0: #f7f8f9;
  --theme-1-color-0: #333;
  --theme-1-box-shadow-0: 0px 2px 2px 0px rgb(197 198 199 / 50%);
  --theme-2-bg-color-selected-0: #24b248;
  --theme-2-bg-color-0: #245366;
  --theme-2-bg-color-1: #103240;
  --theme-2-color-0: #f7f8f9;
  --theme-2-box-shadow-0: 0 5px 10px 3px rgb(21 21 21 / 62%);
  --bg-color-selected-0: var(--theme-1-bg-color-selected-0);
  --bg-color-0: var(--theme-1-bg-color-0);
  --color-0: var(--theme-1-color-0);
  --box-shadow-0: var(--theme-1-box-shadow-0);
}

.welcome-window {
  background-color: #e8f4f9;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./app/components/App/style.css"],"names":[],"mappings":"AAAA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AAQjB;;AANE;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,sCAAsC;EACtC,6BAA6B;EAC7B,uBAAuB;EACvB,8DAA8D;EAC9D,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uCAAuC;EACvC,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf","sourcesContent":["html,\nbody,\n#app {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  -webkit-font-smoothing: antialiased;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n#dashboard-layout {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 100%;\n\n  &__body {\n    position: relative;\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n  }\n}\n\n:root {\n  --text-color-primary-0: var(--color-grayscale-5);\n  --text-color-primary-1: var(--color-grayscale-6);\n  --text-color-primary-2: var(--color-grayscale-7);\n  --text-color-primary-3: var(--color-grayscale-8);\n  --theme-1-bg-color-selected-0: #fdfdfd;\n  --theme-1-bg-color-0: #f7f8f9;\n  --theme-1-color-0: #333;\n  --theme-1-box-shadow-0: 0px 2px 2px 0px rgb(197 198 199 / 50%);\n  --theme-2-bg-color-selected-0: #24b248;\n  --theme-2-bg-color-0: #245366;\n  --theme-2-bg-color-1: #103240;\n  --theme-2-color-0: #f7f8f9;\n  --theme-2-box-shadow-0: 0 5px 10px 3px rgb(21 21 21 / 62%);\n  --bg-color-selected-0: var(--theme-1-bg-color-selected-0);\n  --bg-color-0: var(--theme-1-bg-color-0);\n  --color-0: var(--theme-1-color-0);\n  --box-shadow-0: var(--theme-1-box-shadow-0);\n}\n\n.welcome-window {\n  background-color: #e8f4f9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
